/*
 * @Author: 温少昌 wenshaochang@huizhihuyu.com
 * @Date: 2024-07-23 14:19:29
 * @LastEditors: 温少昌 wenshaochang@huizhihuyu.com
 * @LastEditTime: 2024-07-23 16:09:09
 * @FilePath: /HZ_API/src/noLogin/getAgentDetails.js
 * @Description: 不登录获取智能体信息
 */
import getBaseUrl from '../utils/getBaseUrl';
import axios from 'axios';
const baseUrl = getBaseUrl();
export const getAgentDetails = function getAgentDetails(tenantId, agentNo, linkNo) {
    const reqUrl = baseUrl + `/bbs/b/admin/agent/info/get/by/noLogin/${agentNo}`;
    axios.get(reqUrl, {
        params: {
            linkNo: linkNo
        },
        headers: {
            'Tenant-Id': tenantId
        }
    }).then((res) => {
        // 请求成功
        console.log('不登录获取智能体信息----', res);
        return res;
    }).catch(function (error) {
        // 请求错误
        console.log(error);
        return error;
    }).finally(function () {
        // 总是会执行
        console.log('finally');
    });
}